<template>
  <div-box class="dark">
    <wallet-head show_type="5" />

    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" :noToken="false"
      url="/api/v1/member/teamList" :data="{ account: account, is_team: is_team }">
      <div-padding padding="4vw">



        <div class="add_box">

          <div-height height="6vw"></div-height>

          <div class="link_box">
            <div class="link_item">
              <div class="link_text">{{ $t('直推有效人数') }} </div>
              <div-height height="3vw"></div-height>
              <div class="link_num">{{ recomd_num }}</div>
            </div>
            <div class="link_item">
              <div class="link_text">{{ $t('会员等级') }} </div>
              <div-height height="3vw"></div-height>
              <div class="link_num" v-if="info.level_id">{{ info.level.level_name }}</div>
              <div class="link_num" v-else> V0</div>

            </div>
          </div>

          <div-height height="6vw"></div-height>

          <div class="link_box2">
            <div class="link_item">
              <div class="link_text">{{ $t('团队人数') }} </div>
              <div-height height="3vw"></div-height>
              <div class="link_num">{{ team_num }}</div>
            </div>
            <div class="link_item">
              <div class="link_text">{{ $t('团队业绩') }} </div>
              <div-height height="3vw"></div-height>
              <div class="link_num">{{ team_amount }}</div>
            </div>
          </div>

          <div-height height="3vw"></div-height>

        </div>

        <div-padding padding="4vw 0">
          <div-padding padding="0 0 4vw 0">
            <div-input>
              <div-card bg='#1e2b3f' padding='3vw' radius='2vw' border="1px solid rgba(32, 197, 149, 1)">
                <van-field :border='false' clearable v-model='account' :placeholder='$t("请输入账号")'>
                  <template #button>
                    <van-button @click="up_down()" size="small" type="primary">{{ $t('搜索') }}</van-button>
                  </template>
                </van-field>
              </div-card>
            </div-input>
          </div-padding>

          <div-flex>
            <div-flex left>
              <div-img width='4vw' height='4vw'>
                <img src="@/assets/img/zujian@2x.png">
              </div-img>
              <div-width width='1vw' />
              <div-text color='#fff' size='4vw' v-if="is_team == 1">
                {{ $t('我的团队') }}
              </div-text>
              <div-text color='#fff' size='4vw' v-else>
                {{ $t('直推列表') }}
              </div-text>
            </div-flex>

            <div-flex right>
              <div-img width='4vw' height='4vw'>
                <img @click="opt()" class="is_team_00" :class="is_team == 1 ? 'is_team_02' : 'is_team_01'"
                  src="@/assets/img/all.png">
              </div-img>
              <div-width width='1vw' />



              <div-text @click.native="opt()" color='#fff' size='4vw' v-if="is_team == 1">{{ $t('显示直推') }}</div-text>
              <div-text @click.native="opt()" color='#fff' size='4vw' v-else>{{ $t('显示团队') }}</div-text>

            </div-flex>

          </div-flex>
        </div-padding>

        <div-card bg='#212748' padding='3vw' margin="0 0 3vw 0" v-for="(item, index) in list" :key="index">
          <div-flex>
            <div-flex left>
              <div-text color='#fff' size='4vw'>{{ $t('个人算力') }}</div-text>
              <div-width width='1vw' />
              <div-text color='#7cdefb' size='4vw' bold>{{ item.power }}</div-text>
            </div-flex>
            <div-flex right>
              <div-text color='#fff' size='4vw' v-if="item.level_id"> {{ item.level.level_name }}</div-text>
              <div-text color='#fff' size='4vw' v-else> V0 </div-text>
              <div-width width='2vw' />
              <div v-if="button_show" class="set_lever" @click="set_lever(item)">{{ $t('级别') }}</div>

            </div-flex>
          </div-flex>

          <div-height height='2vw' />

          <div-flex>
            <div-flex left>
              <div-text color='#fff' size='4vw'>{{ $t('团队业绩') }}</div-text>
              <div-width width='1vw' />
              <div-text color='#7cdefb' size='4vw' bold>{{ item.team_amount }}</div-text>
            </div-flex>
          </div-flex>

          <div-height height='2vw' />

          <div-flex>
            <div-text color='#fff' size='4vw'>{{ formatAddress(item.account) }}</div-text>

            <div-text color='#fff' size='3.5vw'>{{ item.created_at }}</div-text>
          </div-flex>

          <div-height height='2vw' />


        </div-card>
      </div-padding>
    </vant-up-down>


    <van-popup v-model="show" position="left" :style="{ width: '55%', height: '100%' }">
      <div class="navbox">



        <div class="top_bj">
          <div class="address">
            <img src="@/assets/img/close.png" @click="show = false">
          </div>
          <div class="heard_bottom">

            <div class="xinxi">
              <div-img width='18vw' height='18vw' radius="50%" margin="0">
                <img src="@/assets/img/levers.png">
              </div-img>
            </div>

            <div class="dizhi">
              <p class="one">{{ $t('级别') }}</p>
            </div>

          </div>
        </div>

        <div class="caidan">
          <div @click="options(item.id)" v-for="(item, index) in levelList" :key="index">
            <a>
              <div class="icon">
                <img :src="require(`@/assets/img/lever0${index + 1}.png`)">
              </div>
              <p class="one">{{ item.level_name }} </p>
              <van-icon name="arrow" style="margin-left: 1.5vw;" />
            </a>
          </div>
        </div>
      </div>
    </van-popup>

  </div-box>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      opt_id: '',
      levelList: [],
      list: [],
      recomd_num: "",
      team_num: "",
      team_amount: "",
      info: "",
      account: '',
      is_team: 0,
      button_show: false
    }
  },
  created() {
    this.get_info()
    this.get_team()
    this.up_down()
    this.get_list()
  },
  methods: {
    // 工具：格式化地址
    formatAddress(addr) {
      if (!addr) return "";
      return addr.length > 10
        ? addr.substring(0, 6) + "..." + addr.substring(addr.length - 4)
        : addr;
    },
    opt() {
      if (this.is_team == 1) {
        this.is_team = 0
      } else {
        this.is_team = 1
      }
      this.up_down()
    },
    get_info() {

      this.$get({
        url: "/api/v1/member/getMemberInfo",
        success: (res) => {
          this.info = res.data || {};


        },
        fail: () => {

        },
      });
    },
    get_list() {
      this.$get({
        url: "/api/v1/memberLevel/levelList",
        success: (res) => {
          this.levelList = res.data
        },
        tip: () => { },
      })

    },

    get_team() {
      this.$get({
        url: "/api/v1/member/teamTotal",
        success: (res) => {
          this.button_show = res.data.button_show
          this.recomd_num = res.data.recomd_num
          this.team_num = res.data.team_num
          this.team_amount = res.data.team_amount
        },
        tip: () => { },
      })
    },
    set_lever(item) {
      this.opt_id = item.id
      console.log('item', item.id)
      this.show = true
    },

    async options(level_id) {

      const confirm = await this.$dialog.confirm({
        message: this.$t('确定要设置级别吗') + '？',
      }).catch(() => { });

      if (!confirm) return;

      if (this.loading == true) {
        return this.$toast(this.$t("请勿重复提交"))
      }
      this.$toast.loading({
        duration: 0,
        overlay: true
      })
      this.loading = true
      let that = this

      this.$post({
        url: '/api/v1/member/setLevel',
        data: {
          id: this.opt_id,
          level_id: level_id,
        },
        success: (res) => {
          this.up_down()
          this.$toast.clear()
          this.show = false
          setTimeout(() => {

            this.loading = false
          }, 2000)
        },
        tip: () => {
          this.$toast.clear()
          this.show = false
          setTimeout(() => {

            this.loading = false
          }, 2000)
        },
      })

    }
  },
}
</script>
<style lang='less' scoped>
.add_box {
  width: 90vw;
  height: 69vw;
  border-radius: 3vw;
  background: url("~@/assets/img/kuang.png") no-repeat;
  margin: 0 auto;
  background-size: 100%;
  background-position: center;
  padding: 7vw;

  .label {
    font-size: 4vw;
    color: #fff;
    padding: 2vw 0;
  }

  .border {
    display: flex;
    font-size: 4vw;
    color: #fff;
    padding: 1.5vw;
    border: 1px solid #20c595;
    border-radius: 2vw;
    justify-content: space-between;

    .icon {
      font-size: 10vw;
      height: 4vw;
      line-height: 4vw;
    }
  }
}


.link_box {
  display: flex;
  justify-content: center;

  .link_item {
    width: 100%;

    .link_text {
      text-align: center;
      font-size: 4vw;
    }

    .link_num {
      text-align: center;
      font-size: 5vw;
      font-weight: bold;
    }
  }
}

.link_box2 {
  display: flex;
  justify-content: space-between;

  .link_item {
    width: 45vw;

    .link_text {
      text-align: center;
      font-size: 4vw;
    }

    .link_num {
      text-align: center;
      font-size: 5vw;
      font-weight: bold;
    }
  }
}

/deep/.van-empty {
  padding-top: calc((100vh - 200vw) / 2) !important;
  padding-bottom: calc((100vh - 200vw) / 2) !important;
}

.set_lever {
  background: #20c595;
  border-radius: 3vw;
  padding: 1vw 2vw;
  font-size: 3vw;
}


/deep/.van-overlay {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

/deep/.van-popup {
  width: 100%;
  background-color: rgba(39, 44, 82, 1);

  .navbox {
    width: 100%;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;

    .top_bj {
      padding: 0 15px 20px;


      .address {
        width: 100%;
        padding: 20px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 0;

        p {
          font-size: 20px;
          font-weight: 550;
        }

        img {
          width: 20px;
          height: 20px;
        }
      }

      .heard_bottom {
        .xinxi {
          display: flex;

          justify-content: center;

          img {
            width: 18vw;
            height: 18vw;
          }


        }

        .dizhi {
          border-radius: 2vw;
          padding: 1vw 3vw;
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          text-align: center;

          p {
            flex: 1;
            font-size: 4vw;
            font-weight: 550;
            color: #fff;
          }

          img {
            width: 4vw;
            height: 4vw;
          }
        }
      }
    }

    .caidan {
      a {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 3vw 4vw;
        border-bottom: 1px solid #101221;

        // img {
        //   width: 18px;
        //   height: 18px;
        //   object-fit: contain;
        // }

        .icon {
          width: 8vw;
          height: 8vw;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        p {
          flex: 1;
          padding: 0 15px 0 7px;
          color: #ffffff;
          font-size: 16px;
          font-weight: 600;
        }

        span {
          width: 4vw;
          height: 4vw;

          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }

      .active {
        background: #101221;

        p {
          color: #fff !important;
        }
      }
    }
  }
}

.van-cell {
  border-radius: 0 !important;
}

.van-button--primary {
  background: #20c595;
}

.is_team_00 {
  transition: all 0.5s ease-in-out;
}

.is_team_01 {
  transform: rotate(180deg);
}

.is_team_02 {
  transform: rotate(0);
}
</style>